import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {Group} from '../../../graphql/groups.datatypes';
import {gqlGroup} from '../getGroup.api';
import {CreateGroupMemberVars} from '../GroupMemberDetails/createGroupMember.api';

export interface CreateGroupInput {
  data: {
    tour_resource_id?: number
    hotel_resource_id?: number
    name?: string
    description?: string
    description_resort?: string
    description_whats_included?: string
    description_checkin?: string
    editing_level?: number
    start_date?: string
    end_date?: string
    admissions_cutoff?: string
    start_date_additional?: string
    end_date_additional?: string
    max_additional_nights?: number
    invoice_document_id?: number
    convenience_fee?: number
    credit_card_fee?: number
    comp_dollar_value?: number
    comp_ratio?: number
    comp_dollar_estimate?: number
    comp_final_value?: number
    default_authorize_members?: boolean
    validated?: boolean
    disabled?: boolean
    locked?: boolean
    booking_tool_edit_cutoff?: string
    description_insurance?: string

    members?: {
      create?: CreateGroupMemberVars[]
    }
  }
}

interface CreateGroupData {
  createGroup: Group
}

export const CREATE_GROUP_MUTATION = gql`
    mutation createGroup($data: CreateGroupInput!) {
        createGroup(data: $data) {
            ${gqlGroup}
        }
    }
`;

export const createGroup = () => useMutation<CreateGroupData, CreateGroupInput>(
  CREATE_GROUP_MUTATION,
  {
    update: updateCacheByType('Group'),
  }
);

export default createGroup;